// Helper function to validate email format
export var isValidEmail = function (email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
export var getCookie = function (cookieName) {
    var cookies = document.cookie.split(";");
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var _a = cookie.trim().split("="), name_1 = _a[0], value = _a[1];
        if (name_1 === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
};
export var isAuthenticated = function () {
    var authStatus = getCookie("isAuthenticated");
    return authStatus === "true";
};
export var addBypassHeaders = function (headers) {
    var BYPASS_ENV_ID = process.env.REACT_BYPASS_ENV_ID;
    var dummy_user_id = process.env.REACT_DUMMY_USER_ID;
    if (BYPASS_ENV_ID) {
        headers["current_env"] = BYPASS_ENV_ID;
        dummy_user_id && (headers["dummy_user_id"] = dummy_user_id);
    }
    return headers;
};
export var getImageUrl = function (fileName) {
    return "".concat(process.env.REACT_APP_IMAGE_BASE_URL, "/").concat(fileName);
};
